<div class="container">
  <div class="col-md-12 mb-2 empl-tptxt">
    <h3>Data Repository</h3>
  </div>
  <div class="row row-cols-2 row-cols-lg-3 g-2 g-lg-3 mx-0 mt-0">
    <div class="col" *ngFor="let title of (filteredQuickSelectOptions$ | async)">
      <div class="miangbdpg-boxxcont" (click)="navigateToSummaryPage(title.id)">
        <div class="col">
          <div class="p-5">
            <div class="empl-tptxt link">
              <h3>{{ title.name }}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
